import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const container = document.getElementById('root')

ReactDOM.render(
  <div>
    <App />
  </div>, container);

  
